import { render, staticRenderFns } from "./ReminderDate.vue?vue&type=template&id=391bdb85&"
import script from "./ReminderDate.vue?vue&type=script&lang=js&"
export * from "./ReminderDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports